const interactionStatusOptions = [
    { id: "no_contact_attempt", value: "Sem primeiro contato" },
    { id: "awaiting_response", value: "Contato realizado, aguardando resposta" },
    { id: "contacted", value: "Contato efetivo" },
    { id: "no_activity", value: "Sem atividade registrada" },
]

export { interactionStatusOptions }
